export default __webpack_public_path__ + "static/media/1012.22b67074.png";